import React, { Component } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import throttle from 'lodash/throttle';

import './media-query-size.less';

const zIndexSizes = ['sm', 'md', 'lg'];

class MediaQuerySize extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleResize = this.handleResize.bind(this);
    this.throttledResize = throttle(this.handleResize, 10);
  }

  componentDidMount() {
    window.setTimeout(this.throttledResize, 100);
    window.addEventListener('resize', this.throttledResize);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.size !== this.state.size) {
      this.props.onSizeChange(this.state.size);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.throttledResize);
  }

  getSize() {
    return this.state.size;
  }

  handleResize() {
    const node = this.mediaQuerySize;

    // prevents errors on jsdom tests
    if (!node) {
      return;
    }

    const zIndex = window.getComputedStyle(node).getPropertyValue('z-index');

    // If zIndex of this component hasn't been set yet, try again in 100ms.
    if (zIndex === 'auto') {
      window.setTimeout(this.throttledResize, 100);
      return;
    }

    const numericZIndex = +zIndex;
    const size = zIndexSizes[numericZIndex];
    this.setState({ size });
  }

  render() {
    return (
      <div
        ref={(c) => {
          this.mediaQuerySize = c;
        }}
        className="media-query-size"
      />
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
MediaQuerySize.displayName = 'MediaQuerySize';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
MediaQuerySize.propTypes = {
  onSizeChange: PropTypes.func,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
MediaQuerySize.defaultProps = {
  onSizeChange() {},
};

export default MediaQuerySize;
